export default __webpack_public_path__ + "power-button-off.png";